import { render, staticRenderFns } from "./ModalEditarSituacaoRequisicao.vue?vue&type=template&id=3b1f22f4&scoped=true"
import script from "./ModalEditarSituacaoRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarSituacaoRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarSituacaoRequisicao.vue?vue&type=style&index=0&id=3b1f22f4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f22f4",
  null
  
)

export default component.exports